<form
    [formGroup]="establishmentForm"
    (ngSubmit)="submit()"
    class="flex flex-col h-full gap-5"
>
    <app-input-section>
        <div title>Algemeen</div>
        <app-input-group
            label="Vestigingsnaam"
            placeholder="bijv. Groningen"
            name="name"
            [control]="establishmentForm.controls.name"
        />
        <app-input-group
            label="Commissie Percentage"
            placeholder="100"
            name="commissionPercentage"
            type="number"
            [control]="establishmentForm.controls.commissionPercentage"
        />
        <div class="text-sm text-gray-600 mt-2">
            <p><strong>Voorbeelden:</strong></p>
            <ul class="list-disc list-inside mt-1">
                <li>Hoofdaannemer: 100%</li>
                <li>Onderaannemer: 85%</li>
                <li>Sub-onderaannemer: 75%</li>
                <li>Partner: 65%</li>
            </ul>
        </div>
    </app-input-section>

    <app-input-section>
        <div title>Hiërarchie</div>
        <label for="parentEstablishmentId" class="block text-sm font-normal mb-1">Hoofdvestiging</label>
        <app-select
            id="parentEstablishmentId"
            formControlName="parentEstablishmentId"
            [options]="parentEstablishmentOptions()"
        />
        <div class="text-sm text-gray-600 mt-2">
            Selecteer een hoofdvestiging als deze vestiging onder een andere vestiging valt.
            Franchisenemers krijgen automatisch toegang tot onderliggende vestigingen.
        </div>
    </app-input-section>

    <app-input-section>
        <div title>Facturatiegegevens</div>
        <div class="text-sm text-gray-600 mb-4">
            Vul hier de gegevens in die op facturen moeten verschijnen voor de commissie waterfall.
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <app-input-group
                label="Bedrijfsnaam"
                placeholder="bijv. Orange Sales B.V."
                name="billingCompanyName"
                [control]="establishmentForm.controls.billingCompanyName"
            />
            <app-input-group
                label="KVK-nummer"
                placeholder="bijv. 12345678"
                name="billingKvkNumber"
                [control]="establishmentForm.controls.billingKvkNumber"
            />
        </div>

        <app-input-group
            label="Adres"
            placeholder="bijv. Randstad 22-151"
            name="billingAddress"
            [control]="establishmentForm.controls.billingAddress"
        />

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <app-input-group
                label="Postcode"
                placeholder="bijv. 1316 BM"
                name="billingPostalCode"
                [control]="establishmentForm.controls.billingPostalCode"
            />
            <app-input-group
                label="Plaats"
                placeholder="bijv. Almere"
                name="billingCity"
                [control]="establishmentForm.controls.billingCity"
            />
            <app-input-group
                label="Land"
                placeholder="bijv. Nederland"
                name="billingCountry"
                [control]="establishmentForm.controls.billingCountry"
            />
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <app-input-group
                label="BTW-nummer"
                placeholder="bijv. NL866719064B01"
                name="billingVatNumber"
                [control]="establishmentForm.controls.billingVatNumber"
            />
            <app-input-group
                label="IBAN"
                placeholder="bijv. NL09KNAB0610611445"
                name="billingIban"
                [control]="establishmentForm.controls.billingIban"
            />
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <app-input-group
                label="Telefoonnummer"
                placeholder="bijv. 06-12345678"
                name="billingPhone"
                [control]="establishmentForm.controls.billingPhone"
            />
            <app-input-group
                label="E-mailadres"
                placeholder="bijv. facturen@bedrijf.nl"
                name="billingEmail"
                type="email"
                [control]="establishmentForm.controls.billingEmail"
            />
        </div>
    </app-input-section>
</form>
